import styles from './FileSearchBar.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { locationShape } from 'react-router';
import lodash from 'lodash';

import QuickMenu from 'common/components/QuickMenu/QuickMenu';

export class FileSearchBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            updateRouterLocation: lodash.debounce(function(){
                const { router } = this.context;
                router.replace(this.state.location);
            }, 300)
        };
    }

    componentDidMount() {
        const { location } = this.context;
        this.updateLocation(location);
    }

    updateLocation(location){
        this.setState(function(prevState) {
            return {
                location: location,
                updateRouterLocation: prevState.updateRouterLocation
            };
        });
    }

    createChangeHandler(queryKey, value){
        return (function onChangeHandler(e){
            const { location } = this.context;
            value = value || e.target.value;
            const newLocation = lodash.merge({}, location, { query: { [queryKey]: value, offset: 0 } });
            this.updateLocation(newLocation);
            this.state.updateRouterLocation.call(this);

        }).bind(this);
    }

    parseIntIfString(value) {
        return lodash.isString(value) ? parseInt(value) : value;
    }

    getSortOrder(location, query) {
        if (!lodash.isEmpty(query.o)) {
            return query.o;
        }
        return lodash.get(location, ['query', 'o'], '-1');
    }

    getHeaders() {
        const {
            sortBy=[],
            sortOrder=[],
            query
        } = this.props;

        const { location } = this.state;
        const sort = lodash.get(query, ['s'], '');
        const order = this.getSortOrder(location, query);

        const sortHeader = lodash.find(sortBy, { value: sort }) || sortBy[0];
        const sortOrderHeader = lodash.find(sortOrder, { value: this.parseIntIfString(order) });

        return {
            sortHeader: sortHeader ? `Sort ${sortHeader.key}` : '',
            sortOrderHeader: sortOrderHeader ? `By ${sortOrderHeader.key}` : '',
        };
    }

    getSortingOptions(sortOptions, queryKey) {
        return sortOptions.map((so, i) => {
            return {
                label: so.key,
                handler: this.createChangeHandler.call(this, queryKey, so.value)
            };
        });
    }

    // In some cases, location in state may become stale, 
    // use query value passed in if available
    getQuery() {
        const { location } = this.state;
        return !lodash.isNil(lodash.get(this.props.query, ['q'])) ? 
            lodash.get(this.props.query, ['q'], '') :
            lodash.get(location, ['query', 'q'], '');
    }

    renderOptions(){
        const { sortBy, sortOrder } = this.props;
        if(!Array.isArray(sortBy) || !Array.isArray(sortOrder)){
            return null;
        }

        const sortByOptions = this.getSortingOptions(sortBy, 's');
        const sortOrderOptions = this.getSortingOptions(sortOrder, 'o');

        const { sortHeader, sortOrderHeader } = this.getHeaders();

        return (
            <div className={styles.controls} data-cy="FileSearchBar">
                <QuickMenu headerText={sortHeader} theme="secondary" options={sortByOptions} />
                <QuickMenu headerText={sortOrderHeader} theme="secondary" options={sortOrderOptions} />
            </div>
        );
    }

    render(){
        const query = this.getQuery();

        return (
            <div className={styles.search} data-cy="FileSearchBar-render">
                <span className={styles.icon} />
                <input className={styles.textbox} type="text"
                    placeholder={this.props.placeholder || 'Search Files'}
                    value={query} onChange={this.createChangeHandler.call(this, 'q')}
                    data-cy="FileSearchBar-createChangeHandler"/>
                { this.renderOptions() }
            </div>
        );
    }
}

FileSearchBar.propTypes = {
    sortBy: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        value:PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })),
    sortOrder: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })),
    query: PropTypes.object
};

FileSearchBar.contextTypes = {
    router: PropTypes.object.isRequired,
    location: locationShape.isRequired
};

export default FileSearchBar;
